package com.anjuros.website.templates.template6.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.templates.template6.modules.Template6Section
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosIcon
import com.anjuros.website.components.shared.AnjurosImage

import com.anjuros.website.templates.template6.components.OutlineButton
import com.anjuros.website.templates.template6.components.PrimaryButton
import com.anjuros.website.templates.template6.modules.Template6HeroBadge
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.styles.Template6Hero1FontStyle
import com.anjuros.website.templates.template6.styles.Template6Hero2FontStyle
import com.anjuros.website.templates.template6.styles.Template6HeroColumnStyle
import com.anjuros.website.templates.template6.styles.Template6HeroContainerStyle
import com.anjuros.website.templates.template6.util.ResKey
import com.anjuros.website.templates.template6.util.Template6Constants
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text


@Composable
fun Template6MainSection() {

    Box(
        modifier = Modifier
            .id(Template6Section.Home.id)
            .fillMaxSize()

    ) {
        AnjurosImage(
            modifier = Modifier.fillMaxSize()
                .displayIfAtLeast(Breakpoint.LG)
                .objectFit(ObjectFit.Cover)
            ,
            src = "template6_hero.jpg",
            alt = "current selection"
        )
        AnjurosImage(
            modifier = Modifier.fillMaxSize()
                .displayUntil(Breakpoint.LG)
                .objectFit(ObjectFit.Cover)
            ,
            src = "template6_hero_mobile.jpg",
            alt = "current selection"
        )
        // Dark Overlay
        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(rgba(0, 0, 0, 0.62))
        )

        Column(
            modifier = Template6HeroContainerStyle.toModifier()
                .displayIfAtLeast(Breakpoint.LG)
                .fillMaxHeight()

                .padding(top = 200.px, bottom = 20.px),
            verticalArrangement = Arrangement.SpaceBetween,
            horizontalAlignment = Alignment.Start

        ) {

            HeroContent()

            HeroHighlights()
        }

        Column(
            modifier = Template6HeroContainerStyle.toModifier()
                .displayUntil(Breakpoint.LG)
                .fillMaxHeight()

                .padding(top = 140.px, bottom = 20.px),
            verticalArrangement = Arrangement.SpaceBetween,
            horizontalAlignment = Alignment.CenterHorizontally

        ) {

            HeroContent()

            HeroHighlights()
        }
    }
}

@Composable
private fun HeroContent() {

    Column(
        modifier = Template6HeroColumnStyle.toModifier()
    ) {

        P(
            attrs = Template6Hero1FontStyle.toModifier()
                .fontWeight(FontWeight.Bold)
                .color(Colors.White)
                .margin(bottom = 28.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_HERO_TITLE))
        }

        P(
            attrs = Modifier
                .fontSize(24.px)
                .fontWeight(FontWeight.SemiBold)
                .color(Template6Theme.Secondary.rgb)
                .margin(bottom = 24.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_HERO_SUBTITLE))
        }

        P(
            attrs = Template6Hero2FontStyle.toModifier()
                .fontSize(20.px)
                .lineHeight(36.px)
                .color(rgb(235,235,235))
                .margin(bottom = 42.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_HERO_DESCRIPTION))
        }

        Row(
            modifier = Modifier.displayIfAtLeast(Breakpoint.LG)
                .gap(20.px)
        ) {

            PrimaryButton(
                text = ResKey.BUTTON_QUOTE,
                path = "#contact",
            )

            OutlineButton(
                text = ResKey.BUTTON_CALL,
                path = "tel:${Template6Constants.CLIENTS_PHONE}"
            )
        }

        Column(
            modifier = Modifier.displayUntil(Breakpoint.LG)
                .gap(20.px)
        ) {

            PrimaryButton(
                text = ResKey.BUTTON_QUOTE,
                path = "#contact",
            )

            OutlineButton(
                text = ResKey.BUTTON_CALL,
                path = "tel:${Template6Constants.CLIENTS_PHONE}"
            )
        }
    }
}

@Composable
private fun HeroHighlights() {

    Row(
        modifier = Modifier.displayIfAtLeast(Breakpoint.LG)
            .margin(top = 120.px)
            .gap(48.px)
    ) {

       Template6HeroBadge.entries.forEach { template6HeroBadge ->
           HeroBadge(template6HeroBadge = template6HeroBadge)
       }
    }

    Column(
        modifier = Modifier.displayUntil(Breakpoint.LG)
            .margin(top = 80.px, left = 20.px)
            .gap(24.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.Start
    ) {

        Template6HeroBadge.entries.forEach { template6HeroBadge ->
            HeroBadge(template6HeroBadge = template6HeroBadge)
        }
    }
}

@Composable
private fun HeroBadge(
   template6HeroBadge: Template6HeroBadge
) {

    Row(
        modifier = Modifier
            .gap(7.px)
            .alignItems(AlignItems.Center)
    ) {

        AnjurosIcon(
            modifier = Modifier.size(30.px)
            ,
            src = template6HeroBadge.icon,
            alt = "sole trader values"
        )

        P(
            attrs = Modifier
                .fontSize(18.px)
                .fontWeight(FontWeight.Medium)
                .color(Colors.White)
                .margin(0.px)
                .toAttrs()
        ) {
            Text(LocalText(template6HeroBadge.text))
        }
    }
}


